import { useState, useEffect } from "react";
import "../styles/Projects.css";
import ProjectDisplay from "./ProjectDisplay";

function Projects() {
  const [selectedTab, setSelectedTab] = useState("Current Projects");
  const [selectedProject, setSelectedProject] = useState("");

  const ProjectTabs = [
    { name: "Current Projects" },
    { name: "Completed Projects" },
    // { name: "Planned Projects" },
    // { name: "Project Map" },
  ];

  const currentProjects = [
    {
      index: 1,
      name: "Granary Park Phase 3",
      images: {
        highQuality: [
          "../assets/projects/current/high_quality/Granary-ph3-before.png",
          "../assets/projects/current/high_quality/Granary-ph3-after.png",
        ],
        lowQuality: [
          "../assets/projects/current/low_quality/Granary-ph3-before.png",
          "../assets/projects/current/low_quality/Granary-ph3-after.png",
        ],
      },
    },
    {
      index: 2,
      name: "Madeira Phase 3",
      images: {
        highQuality: [
          "../assets/projects/current/high_quality/Madeira-ph3-before.png",
          "../assets/projects/current/high_quality/Madeira-ph3-after.png",
        ],
        lowQuality: [
          "../assets/projects/current/low_quality/Madeira-ph3-before.png",
          "../assets/projects/current/low_quality/Madeira-ph3-after.png",
        ],
      },
    },
    {
      index: 3,
      name: "Parcel 61",
      images: {
        highQuality: [
          "../assets/projects/current/high_quality/Reinhold61-before.png",
          "../assets/projects/current/high_quality/Reinhold61-after.png",
        ],
        lowQuality: [
          "../assets/projects/current/low_quality/Reinhold61-before.png",
          "../assets/projects/current/low_quality/Reinhold61-after.png",
        ],
      },
    },
    {
      index: 4,
      name: "Trailmark 12",
      images: {
        highQuality: [
          "../assets/projects/current/high_quality/Trailmark-12-before.png",
          "../assets/projects/current/high_quality/Trailmark-12-after.png",
        ],
        lowQuality: [
          "../assets/projects/current/low_quality/Trailmark-12-before.png",
          "../assets/projects/current/low_quality/Trailmark-12-after.png",
        ],
      },
    },
    {
      index: 5,
      name: "Trailmark 13",
      images: {
        highQuality: [
          "../assets/projects/current/high_quality/Trailmark13-before.png",
          "../assets/projects/current/high_quality/Trailmark13-after.png",
        ],
        lowQuality: [
          "../assets/projects/current/low_quality/Trailmark13-before.png",
          "../assets/projects/current/low_quality/Trailmark13-after.png",
        ],
      },
    },
  ];

  const completedProjects = [
    {
      index: 1,
      name: "Creekview Trail 1&2",
      images: {
        highQuality: [
          "../assets/projects/completed/high_quality/Creekview-1-2-before.png",
          "../assets/projects/completed/high_quality/Creekview-1-2-after.png",
        ],
        lowQuality: [
          "../assets/projects/completed/low_quality/Creekview-1-2-before.png",
          "../assets/projects/completed/low_quality/Creekview-1-2-after.png",
        ],
      },
    },
    {
      index: 2,
      name: "Creekview Trail 5",
      images: {
        highQuality: [
          "../assets/projects/completed/high_quality/Creekview-5-before.png",
          "../assets/projects/completed/high_quality/Creekview-5-after.png",
        ],
        lowQuality: [
          "../assets/projects/completed/low_quality/Creekview-5-before.png",
          "../assets/projects/completed/low_quality/Creekview-5-after.png",
        ],
      },
    },
    {
      index: 3,
      name: "Granary Park Phase 2",
      images: {
        highQuality: [
          "../assets/projects/completed/high_quality/Granary-ph2-before.png",
          "../assets/projects/completed/high_quality/Granary-ph2-after.png",
        ],
        lowQuality: [
          "../assets/projects/completed/low_quality/Granary-ph2-before.png",
          "../assets/projects/completed/low_quality/Granary-ph2-after.png",
        ],
      },
    },
    {
      index: 4,
      name: "Grand Oaks",
      images: {
        highQuality: [
          "../assets/projects/completed/high_quality/Grandoaks-before.png",
          "../assets/projects/completed/high_quality/Grandoaks-after.png",
        ],
        lowQuality: [
          "../assets/projects/completed/low_quality/Grandoaks-before.png",
          "../assets/projects/completed/low_quality/Grandoaks-after.png",
        ],
      },
    },
    {
      index: 5,
      name: "McGirts Creek",
      images: {
        highQuality: [
          "../assets/projects/completed/high_quality/Mcgirts-creek-before.png",
          "../assets/projects/completed/high_quality/Mcgirts-creek-after.png",
        ],
        lowQuality: [
          "../assets/projects/completed/low_quality/Mcgirts-creek-before.png",
          "../assets/projects/completed/low_quality/Mcgirts-creek-after.png",
        ],
      },
    },
  ];

  const handleClick = (item) => {
    setSelectedTab(item.name);
  };

  // Update selectedProject based on the selectedTab
  useEffect(() => {
    if (selectedTab === "Current Projects") {
      setSelectedProject(currentProjects[0].name); // Set to first project's name
    } else if (selectedTab === "Completed Projects") {
      setSelectedProject(completedProjects[0].name); // Set to first project's name
    }
  }, [selectedTab]);

  return (
    <>
      <div className="project-container">
        <div className="project-content">
          <div className="project-header">
            <div className="project-tabs">
              {ProjectTabs.map((item, index) => (
                <h1
                  key={index}
                  className={
                    selectedTab === item.name ? "tab-title active" : "tab-title"
                  }
                  onClick={() => handleClick(item)}
                >
                  {item.name}
                </h1>
              ))}
            </div>
          </div>

          <div className="photo-content">
            {/* Current Projects */}
            {selectedTab === "Current Projects" && (
              <ProjectDisplay
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                projectItems={currentProjects}
              />
            )}

            {selectedTab === "Completed Projects" && (
              <ProjectDisplay
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                projectItems={completedProjects}
              />
            )}
            {selectedTab === "Project Map" && <h1> Map</h1>}
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
